<template>
  <div>
    <div
      class="evaluatee-carousel py-2"
      :class="{ 'noprint evaluatee-carousel-sticky': window_top > 318 }"
    >
      <div v-if="window_top > 318" class="current-evaluatee-label">
        <strong>
          {{ $t("evaluations.newEvaluations.currentlyEvaluating") }}:
        </strong>
      </div>
      <EvaluateeCarousel
        :key="key_evaluatee"
        :current_users="evaluatee_evaluation_list"
        :actualTest="actualTest"
        :sticky="window_top > 318 ? true : false"
        :skip_corrected="true"
        :evaluator_view="evaluator_view"
        @student_selcted="slotStudentSelected"
      ></EvaluateeCarousel>
    </div>
  </div>
</template>

<script>
import * as names from "@/store/names";
import { mapGetters } from "vuex";
export default {
  name: "SelectedEvaluatee",
  components: {
    EvaluateeCarousel: () => import("./EvaluateeCarousel"),
  },
  props: {
    actualTest: {
      type: Object,
    },
    evaluation: {
      type: Object,
      required: true,
    },
    evaluator_view: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      key_evaluatee: 0,
      window_top: 0,
    };
  },
  computed: {
    ...mapGetters({
      Tests: names.NEW_TESTS,
      sections_store: names.SECTIONS,
    }),
    section() {
      if (this.evaluation && this.evaluation.scope == 1)
        return this.sections_store.find(
          (x) => x.id == this.evaluation.scope_id
        );
      else return null;
    },
    evaluatee_evaluation_list() {
      let user_list = [];
      // user_list = user_list.concat(this.evaluation.evaluatees);
      this.Tests.filter((x) => x.evaluation == this.evaluation.id).forEach(
        (test) => {
          user_list = user_list.concat(test.evaluatees);
        }
      );
      // if (this.section) {
      //   user_list = user_list.concat(this.section.students);
      // }
      return [...new Set(user_list)];
    },
  },
  methods: {
    onScroll(e) {
      this.window_top = e.target.documentElement.scrollTop;
    },
    slotStudentSelected(user_id) {
      this.$emit("selected_user", user_id);
    },
  },
  watch: {
    evaluatee_evaluation_list() {
      this.key_evaluatee++;
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScroll);
  },
  created() {
    window.addEventListener("scroll", this.onScroll);
  },
};
</script>

<style scoped>
.evaluatee-carousel {
  background: var(--kl-color-accent-medium);
  box-shadow: 0 1px 7px -4px var(--secondary-color);
  padding-top: 1.5em;
  transition: 0.2s;
  display: flex;
  align-items: center;
}
.evaluatee-carousel-sticky {
  /* El riel de navegación izquierdo (Toolbar) reserva una columna fija:
     60px colapsado / 248px expandido (ver .has-rail en App.vue). Como esta
     barra es position:fixed, el padding-left del riel NO la desplaza, así que
     la anclamos con left + right (en lugar de width al 100% del viewport) para
     que arranque a la derecha del Toolbar y no se solape con él. */
  max-height: 62px;
  background: var(--kl-color-accent-medium);
  color: white;
  box-shadow: 0 1px 7px -4px var(--secondary-color);
  padding-top: 0;
  padding-bottom: 0;
  align-items: center;
  transition: left 0.22s ease, right 0.22s ease;
  position: fixed;
  top: 4.1em;
  left: 60px;
  right: 0;
  z-index: 300;
}
/* Riel expandido: la barra se corre para dejar la columna de 248px. */
body.kl-rail-expanded .evaluatee-carousel-sticky {
  left: 248px;
}
/* En móvil el riel no reserva columna (se superpone), así que la barra
   vuelve a ocupar todo el ancho disponible. Además el navbar pasa a 2 filas
   (alto ~98px, ver #app.has-rail en App.vue), así que bajamos la barra para
   que no quede tapada por el navbar. */
@media (max-width: 768px) {
  .evaluatee-carousel-sticky {
    left: 0;
    top: 5.2em;
  }
}
.current-evaluatee-label {
  /* transform: translateY(-30%); */
  margin-left: 0.5em;
  margin-right: 1em;
  /* width: calc(40% + 10px); */
  width: 250px;
}
</style>